import LocalPharmacyOutlined from '@mui/icons-material/LocalPharmacyOutlined'

import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

import { getPhoneFormatted } from '@shared/utils'

import Section from '@components/Details/Section'

import { CycleOptions } from '../CBORuleSet.utils'
import Field from './Field'

export default function PharmacyFinancials({ cbo, ruleSets, cboIsLoading, ruleSetsAreLoading }) {
  const financials = ruleSets?.financials

  return (
    <Section title="Pharmacy & Financials" icon={<LocalPharmacyOutlined />}>
      <Stack sx={{ gap: 2 }}>
        <Stack sx={{ gap: 1 }}>
          <Field
            label="Primary Pharmacy"
            isLoading={cboIsLoading}
            value={cbo?.primaryPharmacy && <Pharmacy data={cbo.primaryPharmacy} />}
          />
          <Field
            label="Secondary Pharmacy"
            isLoading={cboIsLoading}
            value={cbo?.secondaryPharmacy && <Pharmacy data={cbo.secondaryPharmacy} />}
          />
        </Stack>
        <Stack sx={{ gap: 1 }}>
          <Typography variant="subtitle1">When Pharmacy is Tx outside of CBO pharmacy network, CBO will pay for:</Typography>
          <Field label="Patient Requests Transfer" isLoading={ruleSetsAreLoading} value={CycleOptions[financials?.patientTransfers]} />
          <Field label="Payor Requires Transfer" isLoading={ruleSetsAreLoading} value={CycleOptions[financials?.payorRequiresTransfer]} />
          <Field label="Fee for Service (Medicaid)" isLoading={ruleSetsAreLoading} value={CycleOptions[financials?.feeForService]} />
        </Stack>
      </Stack>
    </Section>
  )
}

function Pharmacy({ data }) {
  return (
    <Stack>
      <Typography>{data.name}</Typography>
      {data.address && <Typography sx={{ color: 'text.secondary' }}>{data.address}</Typography>}
      <Typography sx={{ color: 'text.secondary' }}>{[data.city, data.state].filter(Boolean).join(', ')}</Typography>
      {data.phone && <Typography sx={{ color: 'text.secondary' }}>{getPhoneFormatted(data.phone)}</Typography>}
    </Stack>
  )
}
